import SvgIcon from "@mui/material/SvgIcon";
import SitePrepSvg from "../live-svg/site-prep.svg";
import React from "react";

export function SitePrepIcon(props) {
    return (
        <SvgIcon {...props}>
            <SitePrepSvg color={props.color || "#36415D"}/>
        </SvgIcon>
    )
}
